import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-payment-complete',
    templateUrl: '../svgs/PaymentCompleted.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--payment-complete'
    },
    standalone: false
})
export class TellerOnlineIconPaymentComplete {
}
